export default __webpack_public_path__ + "static/media/no_content.175a76fe.png";